import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

function Tab({ user, path, exact, title, onClick }) {
    return (
        <NavLink activeClassName="active" to={path} exact={exact} onClick={onClick}>
            {title}
        </NavLink>
    );
}

Tab.propTypes = {
    path: PropTypes.string.isRequired,
    exact: PropTypes.bool,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export function NewsTab({ onClick }) {
    return <Tab path="/news" title="Новости" exact onClick={onClick} />;
}

NewsTab.propTypes = {
    onClick: PropTypes.func,
};

export function LawsTab({ onClick }) {
    return <Tab path="/laws" title="Право" exact onClick={onClick} />;
}

LawsTab.propTypes = {
    onClick: PropTypes.func,
};

// export function MapTab({ onClick, userToken }) {
//     return <Tab path={`/map/${userToken}`} title="Указ 756" onClick={onClick} />;
//     // return <Tab path={`/map/${userToken}`} title="COVID-19" onClick={onClick} />;
// }

// MapTab.propTypes = {
//     onClick: PropTypes.func,
//     userToken: PropTypes.string.isRequired,
// };

export function CalendarTab({ onClick }) {
    return <Tab path={`/calendar`} title="Календарь" onClick={onClick} />;
}

CalendarTab.propTypes = {
    onClick: PropTypes.func,
};

export function LawsDigestsOldTab({ onClick }) {
    return <Tab path={`/laws-digests-old`} title="Дайджесты" onClick={onClick} />;
}

LawsDigestsOldTab.propTypes = {
    onClick: PropTypes.func,
};

export function LawsDigestsTab({ onClick }) {
    return <Tab path={`/laws-digests`} title="Дайджесты" onClick={onClick} />;
}

LawsDigestsTab.propTypes = {
    onClick: PropTypes.func,
};
export function NewsDigestsTab({ onClick }) {
    return <Tab path={`/news-digests`} title="Новостные Дайджесты" onClick={onClick} />;
}

NewsDigestsTab.propTypes = {
    onClick: PropTypes.func,
};

export function StatisticsTab({ onClick }) {
    return <Tab path={`/statistics`} title="Статистика" onClick={onClick} />;
}

StatisticsTab.propTypes = {
    onClick: PropTypes.func,
};

export function ReportsTab({ onClick }) {
    return <Tab path={`/reports`} title="Отчетность" onClick={onClick} />;
}

ReportsTab.propTypes = {
    onClick: PropTypes.func,
};

export function ThemeReportsTab({ onClick }) {
    return <Tab path={`/theme-reports`} title="Отчеты по теме" onClick={onClick} />;
}

ThemeReportsTab.propTypes = {
    onClick: PropTypes.func,
};

export function RiskCardTab({ onClick }) {
    return <Tab path={`/risk-card`} title="Карта рисков" onClick={onClick} />;
}

RiskCardTab.propTypes = {
    onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/navigation/nav/tabs/index.js